<script lang="ts">
	import Star from '@lucide/svelte/icons/star';

	let { stars }: { stars: number } = $props();

	const fullStars = Math.floor(stars);
	const hasPartial = stars % 1 !== 0;
	const emptyStars = 5 - Math.ceil(stars);
	const partialStarWidth = (stars % 1) * 100;
</script>

<div class="flex gap-1">
	{#each Array(fullStars) as _}
		<Star fill="#FFD932" color="#FFD932" class="size-5 md:size-6" />
	{/each}

	{#if hasPartial}
		<div class="relative size-5 md:size-6">
			<Star color="#FFD932" class="absolute inset-0 size-5 md:size-6" />
			<Star
				fill="#FFD932"
				color="#FFD932"
				class="absolute inset-0 size-5 md:size-6"
				style={`clip-path: inset(0 ${100 - partialStarWidth}% 0 0);`}
			/>
		</div>
	{/if}

	{#each Array(emptyStars) as _}
		<Star fill="none" color="#FFD932" class="size-5 md:size-6" />
	{/each}
</div>
